import axios from 'axios'
import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode'
import { CognitoAuthResponse, JWTidToken, JwtToken, LoginResponse } from './type/authentication'

export class AuthorizationHandler {
  static get userEmail(): string | undefined {
    let idToken = Cookies.get('idToken')
    if (idToken) {
      const idTokenJwt: JWTidToken | undefined = jwtDecode(idToken)
      return idTokenJwt?.email
    }

    return undefined
  }

  static get idToken(): string | undefined {
    return Cookies.get('idToken')
  }
  static get refreshToken(): string | undefined {
    return Cookies.get('refreshToken')
  }
  static get accessToken(): string | undefined {
    return Cookies.get('accessToken')
  }

  static initSession(payload: LoginResponse): void {
    const accessTokenJwt: JwtToken = jwtDecode(payload.access_token)
    const idTokenJwt: JWTidToken = jwtDecode(payload.id_token)

    Cookies.set('accessToken', payload.access_token, {
      secure: true,
      sameSite: 'strict',
      expires: new Date(accessTokenJwt.exp * 1000),
    })

    if (payload.refresh_token)
      Cookies.set('refreshToken', payload.refresh_token, {
        secure: true,
        sameSite: 'strict',
        expires: 30,
      })

    Cookies.set('idToken', payload.id_token, {
      secure: true,
      sameSite: 'strict',
      expires: new Date(idTokenJwt.exp * 1000),
    })
  }

  static async isSessionValid() {
    if (!AuthorizationHandler.idToken) {
      if (!AuthorizationHandler.refreshToken) {
        return false
      }

      const params = new URLSearchParams()
      params.append('grant_type', 'refresh_token')
      params.append('client_id', process.env.REACT_APP_CLIENT_ID!)
      params.append('client_secret', process.env.REACT_APP_CLIENT_SECRET!)
      params.append('refresh_token', AuthorizationHandler.refreshToken)

      try {
        const response = await axios.post<CognitoAuthResponse>(
          `${process.env.REACT_APP_COGNITO_URL}/oauth2/token`,
          params,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          },
        )

        if (response.data.error) {
          console.error(response.data.errorDescription)
          AuthorizationHandler.clearSession()
          return false
        }

        AuthorizationHandler.initSession(response.data as LoginResponse)
      } catch (error) {
        console.error('Error during token refresh:', error)
        AuthorizationHandler.clearSession()
        return false
      }
    }

    return true;
  }

  static clearSession() {
    if (AuthorizationHandler.idToken) Cookies.remove('idToken')
    if (AuthorizationHandler.refreshToken) Cookies.remove('refreshToken')
    if (AuthorizationHandler.accessToken) Cookies.remove('accessToken')
  }
}
